import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { forDesktopUp, forPhoneOnly, forTabletPortraitUp } from 'src/config/mediaQueries'

export default createUseStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    alignItems: 'center',
    padding: [0, 18],
    [forTabletPortraitUp]: {
      padding: [20, 68],
    },
    [forDesktopUp]: {
      padding: [30, 122],
    },
    [forPhoneOnly]: {
      padding: [0, 24, 24, 24],
    },
  },
  h1: {
    display: 'inline-block',
    ...typography['Lato H4 Bold'],
    [forPhoneOnly]: {
      ...typography['Lato H5 Bold'],
      textAlign: 'center',
      marginTop: 40,
    },
  },
  description: {
    display: 'inline-block',
    ...typography['Lato H5'],
    marginTop: 24,
    [forPhoneOnly]: {
      ...typography['Lato Body 1'],
    },
  },
  headerText: {
    maxWidth: 466,
    marginRight: 72,
    [forPhoneOnly]: {
      maxWidth: 'unset',
      marginRight: 0,
    },
  },
  successImage: {
    [forPhoneOnly]: {
      width: 140,
      height: 'auto',
    },
  },
  info: {
    display: 'flex',
    flexDirection: 'column-reverse',
    alignItems: 'center',
    marginTop: 67,
    margin: 'auto',
    [forTabletPortraitUp]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: 38,
    },
  },
  anaIframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
  anaWrapper: {
    height: '100%',
  },
  closeIcon: {
    position: 'absolute',
    right: '16px',
    top: '16px',
    cursor: 'pointer',
    zIndex: 1,
  },
})
